import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';

import TokenService from "../../services/auth/generateToken.service";

import '../../styles/style.scss';
import '../../styles/paymentScreenResponseStyle.scss';

export const AdvancedPaymentScreenSuccess = () => {

  useEffect(() => {
    TokenService.getRefreshToken();
    localStorage.setItem("pago-exitoso", "true");
    }, []);

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col p-0 me-1 ms-1">
                  <NavTopMenu />
                  <div className="container ps-3 pe-3 container-size">
                    <div className="row base-container ">
                      <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                        <span>Referencia de anticipo</span>
                        <i className="fas fa-angle-right ms-2 me-2"></i>
                        <span>Respuesta</span>
                      </div>
                      <div className="col-12 ps-4 pe-4 pt-3 pb-3">
                        <div className="card-message">
                          <div className="d-flex justify-content-center" >
                          <span className="icon-success-container d-flex align-items-center justify-content-center">
                            <i className="fas fa-check custom-icon-success"></i>
                          </span>
                          </div>
                          <div className="d-flex justify-content-center mt-3" >
                            <span className="text-message">
                              Pago realizado correctamente
                            </span>
                          </div>
                          <div className="d-flex justify-content-center mt-3">
                            <Link to="/operation/advance-payment">
                              <button  
                                className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                                >
                                  Regresar a anticipos
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
            <Footer/>
        </>
    )
}